import { TextField, Card, Box, Button, Typography } from "@mui/material"
import { useForm } from "react-hook-form";
import PropTypes from 'prop-types'


const ResetCard = ({ onReset }) => {

    const { register, handleSubmit } = useForm()

    return (
        <Card>
            <Card raised sx={{ display: 'flex', flexDirection: 'column', p: 2, gap: 1 }}>
                <Typography gutterBottom>Enter your email address below and you will be able to reset your password.</Typography>
                <form onSubmit={handleSubmit(onReset)}>
                    <Box display='flex' flexDirection='column' gap={1}>
                        <TextField label='Email Address' variant='filled' size='small' {...register('email')} />
                        <Button variant='contained' type='submit'>Send Reset Email</Button>
                    </Box>
                </form>
            </Card>
        </Card>
    )
}

ResetCard.propTypes = {
    onReset: PropTypes.func,
}

export default ResetCard